import { render, staticRenderFns } from "./EditDocLabBiopsy.vue?vue&type=template&id=9bce2f84&scoped=true"
import script from "./EditDocLabBiopsy.vue?vue&type=script&lang=js"
export * from "./EditDocLabBiopsy.vue?vue&type=script&lang=js"
import style0 from "./EditDocLabBiopsy.vue?vue&type=style&index=0&id=9bce2f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bce2f84",
  null
  
)

export default component.exports